import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { PersonCardProps } from "../PersonCard";
import { PersonBlockDesktop } from "./desktop";
import { PersonBlockMobile } from "./mobile";

export const PersonBlock: React.FC<
  Pick<PersonCardProps, "showMobileMenu" | "isEdit" | "showEdit" | "form">
> = ({ showMobileMenu = false, isEdit, showEdit = false, form = false }) => {
  return (
    <ResponsiveBlockSwitcher
      desktop={<PersonBlockDesktop />}
      mobile={
        <PersonBlockMobile
          showMobileMenu={showMobileMenu}
          isEdit={isEdit}
          showEdit={showEdit}
          form={form}
        />
      }
    />
  );
};
